import { useTracker } from '@jetshop/core/analytics/Analytics';
import { useCallback } from 'react';
import { trackProductEvent } from '@jetshop/core/analytics/tracking';
import { unSlugify } from '@jetshop/core/analytics/integrations/unslugify';
import { breadcrumbsWithoutProduct } from '@jetshop/core/analytics/utils/breadcrumbsWithoutProduct';
export function getArticleNumber(product, selectedVariation) {
    var _a, _b;
    return ((_b = (_a = product === null || product === void 0 ? void 0 : product.variants) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.length) > 0
        ? selectedVariation === null || selectedVariation === void 0 ? void 0 : selectedVariation.articleNumber
        : product === null || product === void 0 ? void 0 : product.articleNumber;
}
export function useTrackProductAdd(selectedVariation) {
    const track = useTracker();
    return useCallback(function trackProductVariant(product, quantity) {
        var _a, _b, _c;
        track(trackProductEvent({
            action: 'add',
            product,
            quantity,
            selectedVariation,
            category: breadcrumbsWithoutProduct((_a = product.primaryRoute) === null || _a === void 0 ? void 0 : _a.breadcrumbs) ||
                unSlugify((_c = (_b = product.canonicalCategory) === null || _b === void 0 ? void 0 : _b.primaryRoute) === null || _c === void 0 ? void 0 : _c.path) ||
                ''
        }));
    }, [selectedVariation, track]);
}
export function getCommentsFromFormikValues(values) {
    return Object.keys(values.comments).map((name) => {
        return {
            name,
            value: values.comments[name]
        };
    });
}
export function addToCartSuccess({ onAddToCartSuccess, callbackOptions, cartId, setCartId }) {
    return ({ data }) => {
        if (!cartId || data.addToCart.cart.id !== cartId) {
            data.addToCart && setCartId(data.addToCart.cart.id);
        }
        onAddToCartSuccess && onAddToCartSuccess(callbackOptions);
    };
}
export function addToCartError({ onAddToCartError, callbackOptions }) {
    return (error) => {
        console.error('useCartAdder error', error);
        if (!onAddToCartError) {
            throw error;
        }
        onAddToCartError(Object.assign(Object.assign({}, callbackOptions), { error }));
    };
}
//# sourceMappingURL=addToCartUtils.js.map